import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {RouterModule} from '@angular/router';
import {NgxBarcode6Module} from 'ngx-barcode6';
import {SearchFilterModule} from '../search-filter/search-filter.module';
import {ProductDetailComponent} from './components/product-detail/product-detail.component';
import {MatchingProductsComponent} from './components/matching-products/matching-products.component';
import {AddToCartComponent} from './components/add-to-cart/add-to-cart.component';
import {ExperienceTheProductComponent} from './components/experience-the-product/experience-the-product.component';
import {I18NextModule} from 'angular-i18next';
import {CoreModule} from "../../core/core.module";


@NgModule({
  declarations: [
    ProductDetailComponent,
    MatchingProductsComponent,
    AddToCartComponent,
    ExperienceTheProductComponent
  ],
  imports: [
    CommonModule,
    SearchFilterModule,
    RouterModule,
    NgxBarcode6Module,
    I18NextModule,
    CoreModule
  ]
})
export class ProductsModule {
}
